import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { FC } from "react";
import { Button, Modal } from "react-bootstrap";

export const Intro: FC<{ show: boolean, onClose: () => void, startScreen: number }> = ({ show, onClose, startScreen }) => {

    const [currentStage, setCurrentStage] = useState(startScreen)
    const modals = [
        <Modal show={show} centered={true} onHide={() => onClose()}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span className="fs-5">Welcome to the</span><br />
                    <span className="fs-1">Ascentinel Path</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <img src="/img/AscentinelPath.png" alt="AscentinelPath" width={'100%'} />
                <p style={{ textAlign: 'justify' }}>
                    Unleash your real-life challenger and break out of your comfort zone!
                    Whether you're crushing it at the gym, mastering your finances, or conquering a mountain trail -
                    now's the time to level up. With the right dose of dopamine and a playful approach, your
                    real-life battle pass will unlock your full potential.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button className="w-100" onClick={() => setCurrentStage(1)}>Start your journey now!</Button>
            </Modal.Footer>
        </Modal>,
        <Modal show={show} centered={true} onHide={() => onClose()}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span className="fs-1">Categories</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ textAlign: 'justify' }}>
                    Here are 6 categories where you can improve yourself:<br />
                    <br />
                    <b>Health:</b><br />
                    Strengthen your body and mind! Focus on fitness, nutrition, and relaxation. Your body is your most valuable asset.<br />
                    <br />
                    <b>Education:</b><br />
                    Learn something new every day! Train your skills, broaden your horizons - education opens doors.<br />
                    <br />
                    <b>Social:</b><br />
                    Nurture relationships, build connections, and foster empathy. Together, we are stronger.<br />
                    <br />
                    <b>Ideology:</b><br />
                    Find your values and vision. Question, evolve, and live sustainably.<br />
                    <br />
                    <b>Finances:</b><br />
                    Master managing money, build wealth, and achieve financial freedom.<br />
                    <br />
                    <b>Emotions:</b><br />
                    Understand your feelings, find balance, and strengthen your resilience.
                </p>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button className="w-10" onClick={() => setCurrentStage(0)}><FontAwesomeIcon icon={faArrowLeft} /></Button>
                <div>1/4</div>
                <Button className="w-10" onClick={() => setCurrentStage(2)}><FontAwesomeIcon icon={faArrowRight} /></Button>
            </Modal.Footer>
        </Modal>,
        <Modal show={show} centered={true} onHide={() => onClose()}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span className="fs-1">Missions</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ textAlign: 'justify' }}>
                    Set new goals or edit existing ones. The missions are assigned to the 6 categories.<br />
                    <br />
                    <b>Creation:</b><br />
                    When creating missions, you can specify whether they are one-time achievable or repeatable.<br />
                    <br />
                    <img src='/img/mission-screen.png' width={'100%'} alt="mission screen" /><br />
                    <b>Streak:</b><br />
                    A streak is activated when you repeat your mission within the specified time frame. The higher the streak, the higher your multiplier.<br />
                </p>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button className="w-10" onClick={() => setCurrentStage(1)}><FontAwesomeIcon icon={faArrowLeft} /></Button>
                <div>2/4</div>
                <Button className="w-10" onClick={() => setCurrentStage(3)}><FontAwesomeIcon icon={faArrowRight} /></Button>
            </Modal.Footer>
        </Modal>,
        <Modal show={show} centered={true} onHide={() => onClose()}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span className="fs-1">Tinker Coins</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ textAlign: 'justify' }}>
                    <b>What do I earn Tinker Coins for?</b><br />
                    <br />
                    By earning Tinker Coins, you level up your Battle Pass and increase your Elo. You can freely
                    set the reward amount for each mission. Use a weekly scale as a reference for defining your rewards.<br />
                    <br />
                    <b>Balancing:</b><br />
                    You can distribute your weekly income as follows:<br />
                    <br />
                    <b>Perfect Week:</b><br />
                    Earn 200 Tinker Coins<br />
                    <br />
                    <b>Normal Week:</b><br />
                    Earn 100 Tinker Coins<br />
                    <br />
                    <b>Bad Week:</b><br />
                    Earn 50 Tinker Coins<br />
                </p>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button className="w-10" onClick={() => setCurrentStage(2)}><FontAwesomeIcon icon={faArrowLeft} /></Button>
                <div>3/4</div>
                <Button className="w-10" onClick={() => setCurrentStage(4)}><FontAwesomeIcon icon={faArrowRight} /></Button>
            </Modal.Footer>
        </Modal>,
        <Modal show={show} centered={true} onHide={() => onClose()}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span className="fs-1">Approvals</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ textAlign: 'justify' }}>
                    To prevent system abuse and game breaking, there is an approval system.<br />
                    <br />
                    The tasks you complete can be vetoed weekly by your peer reviewer.<br />
                    <br />
                    How do I choose my peer reviewer?<br />
                    <br />
                    By default, the approval lies with us in the backend and is personally reviewed
                    in case of suspicious behavior. Additionally, you have the option to set your personal peer reviewer via the Friends tab.<br />
                </p>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button className="w-10" onClick={() => setCurrentStage(3)}><FontAwesomeIcon icon={faArrowLeft} /></Button>
                <div>4/4</div>
                <Button className="w-10" onClick={() => { setCurrentStage(0); onClose() }}><FontAwesomeIcon icon={faArrowRight} /></Button>
            </Modal.Footer>
        </Modal>
    ]

    return modals[currentStage]
}